import { atom } from 'jotai';
import { ListParamsUser } from '../types';
import { USER_ROLE } from '../lib/constants';

export const clientsPaginationAtom = atom<ListParamsUser>({
  sort: {
    createdAt: 'desc',
  },
  pagination: {
    page: 1,
    take: 50,
  },
  filters: {
    search: '',
    id: {
      $nin: [],
    },
    role: {
      $in: Object.values(USER_ROLE),
    },
  },
} as ListParamsUser);
